import * as React from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import Layout from '../Layout/Layout';
import Typography from '@material-ui/core/Typography/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import { FormControlLabel, Button } from '@material-ui/core';
import * as styles from './StartHere.css';
import CalendlyFrame from '../CalendlyFrame/CalendlyFrame';
import Grid from '@material-ui/core/Grid/Grid';
import routerHistory from '../../history';


const StartHere = () => {
  const [isChecked, setIsChecked] = useState(JSON.parse(localStorage.getItem('isChecked') || '{}'));
  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedIsChecked = { ...isChecked };
    updatedIsChecked[event.target.name] = event.target.checked;
    setIsChecked(updatedIsChecked);
    localStorage.setItem('isChecked', JSON.stringify(updatedIsChecked));
  };

  const isAllChecked = Object.values(JSON.parse(localStorage.getItem('isChecked') || '{}')).every((value) => value === true);

  return (
    <Layout>
      <Grid container justify='center' alignItems='center' direction='column'
            className={styles.gridContainer}>
        <Typography color='primary' variant='display1' className={styles.title}>
          Let's Get You Out Of Debt Now
        </Typography>
        <Typography className={styles.description}>
          Please review and complete each step carefully. After finishing each step, check the
          corresponding boxes to "Get Out Of Debt".
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              name='cb1'
              color='primary'
              checked={isChecked['cb1'] || false}
              onChange={handleCheckBoxChange}
            />
          }
          label={
            <span>
              <strong style={{ color: '#00838f' }}>I hate my debt.</strong> Please watch this video to understand what we mean. This debt payoff planner requires work and is only built for those serious to save money and get out of debt much faster. If you're not serious to get out of debt, please <a
              href={'https://www.tillerhq.com/debt-snowball-spreadsheet/'} target='blank'>consider these free planners</a>.
            </span>
          }
        />
        <Grid container justify='center' alignItems='center'
              style={{ marginBottom: '2rem', marginTop: '1rem' }}>
          <iframe src={'https://www.youtube.com/embed/fZKGaks8lTk?si=WuOBdvjovcbDdKc8'}
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                  allowFullScreen frameBorder='0' className={styles.iframeYt} />
        </Grid>
        <FormControlLabel
          control={
            <Checkbox
              name='cb2'
              color='primary'
              checked={isChecked['cb2'] || false}
              onChange={handleCheckBoxChange}
            />
          }
          label={
            <span>
            <strong style={{ color: '#00838f' }}>Schedule a 15 minute complimentary call with your analyst.</strong> Again, we built this portal for the die hard debt haters. This portal has a lot of functionality to get you out of debt faster so this is a required step.
          </span>
          }
        />
        <Grid container justify='center' alignItems='center' direction='column'>
          <CalendlyFrame />
        </Grid>
        <Grid container justify='center' alignItems='flex-start' direction='column'
              style={{ marginTop: '2rem', marginBottom: '2rem' }}>
          <FormControlLabel
            control={
              <Checkbox
                name='cb3'
                color='primary'
                checked={isChecked['cb3'] || false}
                onChange={handleCheckBoxChange}
              />
            }
            label={
              <span>
          <strong style={{ color: '#00838f' }}>Add Your Debt Accounts.</strong> We will cover this in the call.
        </span>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                name='cb4'
                color='primary'
                checked={isChecked['cb4'] || false}
                onChange={handleCheckBoxChange}
              />
            }
            label={
              <span>
            <strong style={{ color: '#00838f' }}>Add Your Income Accounts.</strong> We will cover this in the call.
          </span>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                name='cb5'
                color='primary'
                checked={isChecked['cb5'] || false}
                onChange={handleCheckBoxChange}
              />
            }
            label={
              <span>
            Put a majority of your <strong style={{ color: '#00838f' }}>extra income towards your priority debt.</strong>
          </span>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                name='cb6'
                color='primary'
                checked={isChecked['cb6'] || false}
                onChange={handleCheckBoxChange}
              />
            }
            label={
              <span>
            See how fast you <strong style={{ color: '#00838f' }}>get out of debt.</strong>
          </span>
            }
          />
        </Grid>
        <Button onClick={() => routerHistory.push('/spendingTracker')} size='large'
                variant='contained' color='primary' disabled={!isAllChecked}>
          Get Out Of Debt
        </Button>
      </Grid>
    </Layout>
  );
};

export default connect(null, null)(StartHere);